import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useCallback } from 'react';

import { AuthService } from "../services/auth-service";
import GeneralTable from "../components/layouts/general-table";
import TitleGrows from "../components/title-grows";

import { useContext } from 'react';
import AuthContext from '../context/auth-context'
import * as userpermission from "../utils/PermissionCheck.js"

export default function UserPermissions() {

  const authCtx = useContext(AuthContext);
  //let items = [...authCtx.permissionList];

  const cols = [
    { label: 'ID', key: 'id', isSortable: false, isVisible: true, },
    { label: 'USERNAME', key: 'username', isSortable: false, isVisible: true, },
    {
      label: 'GROUPS', key: 'groups', isSortable: false, isVisible: true,
      render: (col, row) => {
        return <>
          <ul className="list-group list-group-flush" style={{ listStyleType: "none" }}>
            {row.groups.length > 0 && row.groups.map((e, index) => (
              <li className="list-group-item" style={{ padding: "1px" }} key={index}>
                {e?.name}
              </li>
            ))}
          </ul>
        </>
      }
    },
    {
      label: 'PERMISSIONS', key: 'permissions', isSortable: false, isVisible: true,
      render: (col, row) => {
        return <>
          <ul className="list-group list-group-flush" style={{ listStyleType: "none" }}>
            {row.permissions.length > 0 && row.permissions.map((e, index) => (
              <li className="list-group-item" style={{ padding: "1px" }} key={index}>
                {e?.codename}
              </li>
            ))}
          </ul>
        </>
      }
    },
  ]

  const [isLoading, setIsLoading] = useState(false);

  // let order = true;

  const [pages, setPages] = useState([]);

  const [itemsCount, setItemsCount] = useState(0);
  const [errors, setErrors] = useState([]);

  // let _pageNum = useRef(0)
  // const [pageNum, _setPageNum] = useState(_pageNum.current);
  // const setPageNum = (v) => { _pageNum.current = v; _setPageNum(v) }

  // let _order = useRef({ key: 'id', asc: false })
  // const [order, _setOrder] = useState(_order.current);
  // const setOrder = (v) => { _order.current = v; _setOrder(v) }

  // let _rowsPerPage = useRef(10)
  // const [rowsPerPage, _setRowsPerPage] = useState(_rowsPerPage.current);
  // const setRowsPerPage = (v) => { _rowsPerPage.current = v; _setRowsPerPage(v) }

  const handleChanges = (tableParams) => {
    getData(tableParams)
  };

  const getData = useCallback(async (params = {}) => {

    setIsLoading(true);
    // setPages([])
    // setItemsCount(0)
    const {
      page = 1, page_size = 10, ordering = 'id'
    } = params
    let _params = {
      //id: '',
      //username: localStorage.username,
      //groups: [],
      //user_permissions__codename: 'can_edit_homes'
      page: page,
      page_size: page_size,
      ordering: ordering
    }

    try {
      let resObject = await AuthService.getPermissionList(_params);

      if (!resObject || (resObject?.status && resObject?.status !== 200)) {
        console.log(`Error getPermissionList: `, resObject);
        setPages([])
        setItemsCount(0)
        setIsLoading(false);
        setErrors(`Error getPermissionList: ${resObject?.statusText} - (status ${resObject?.status})`)
        return {
          revalidate: 5,
          notFound: true,
        }
      }
      if (resObject.count > 0) {
        setItemsCount(resObject.count)
        setPages(resObject.results)
        setIsLoading(false);
      }
      else {
        setErrors(`Nessun risultato trovato!`)
      }
    } catch (e) {
      console.log(e);
      return {
        revalidate: 5,
        notFound: true,
      }
    }
  }, [])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getData();
    }, 250)
    return () => {
      clearTimeout(delayDebounceFn)
      setIsLoading(false);
      setPages([])
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className='d-flex flex-column h-100'>
      <div className='flex-grow-0'>
        <TitleGrows txtTitle="Users" />
      </div>
      {userpermission.PermissionCheck('view_user', [...authCtx.permissionList]) ?
        <>
          {errors.length > 0 ? <div>{errors}</div>
            : <div className='flex-grow-1'>
              <GeneralTable
                cols={cols}
                data={pages}
                itemsCount={itemsCount}
                isLoading={isLoading}
                initialOptions={
                  { initialOrdering: { key: 'id', asc: false } }
                }
                handleChanges={handleChanges}
              // generalOptions={{ rowsPerPageOptions: [1, 2, 10, 25, 50] }}
              />
            </div>
          }
        </>
        : <span style={{ textAlign: "center", padding: "6px", fontSize: "1.25rem", fontWeight: "bold", color: "red" }} >
          ATTENZIONE! Non hai i permessi necessari per visualizzare questa lista
        </span>
      }
    </div>
  );
}
